import { appEvents } from "@cayo/shared/components/App/appEvents";
import { IConfirmationModal } from "@cayo/shared/components/dialogs/ConfirmationModal";

export const showConfirmation = (parameters: IConfirmationModal) => {
  appEvents.trigger({
    showControl: {
      controlId: "Dialogs/ConfirmationModal",
      parameters,
    },
  });
};
